import React, { useState } from 'react';
import { useAuth } from "react-oidc-context";
import { composeUrl } from "../../utils/api";
import { getClaimValue } from "../../utils/authUser";
import LimeClaimTypes from "../../models/limeClaimTypes";
import { portalCardSurface, portalPageTitle, portalSecondaryPillButton } from "../../theme/portalLayout";

function Profile() {
  const auth = useAuth()
  const [organisationName] = useState(getClaimValue(auth.user, LimeClaimTypes.OrganisationName));
  const [changePasswordUrl, setChangePasswordUrl] = useState("#");

  React.useEffect(() => {
    const fetchData = async () => {
      const configUrl = composeUrl('configuration');
      const response = await fetch(configUrl);
      const config = await response.json();
      const url = `${config.auth}/Account/ChangePassword?returnUrl=${encodeURIComponent(window.location.href)}`;
      setChangePasswordUrl(url);
    }
    void fetchData();
  }, []);

  return (
    <div>
      <h2 className={portalPageTitle}>Profile</h2>
      <div className={`mt-lg mb-lg p-6 lg:p-8 max-w-3xl ${portalCardSurface}`}>
        <h4 className="font-sans-co font-bold text-portal-teal text-h4 mb-md">Information</h4>
        <p className="text-p1 text-portal-teal mb-sm"><span className="font-bold">Name: </span>{auth.user?.profile.name}</p>
        <p className="text-p1 text-portal-teal mb-sm"><span className="font-bold">Email: </span>{auth.user?.profile.email}</p>
        <p className="text-p1 text-portal-teal mb-0"><span className="font-bold">Organisation: </span>{organisationName}</p>
      </div>
      <h4 className="font-sans-co font-bold text-portal-teal text-h4 mb-sm">Change password</h4>
      <p className="text-p1 text-portal-teal mb-md">Change your password below</p>
      <a className={portalSecondaryPillButton} href={changePasswordUrl}>Change password</a>
    </div>
    );
}

export default Profile;